import styled from "styled-components";
import actionElements from "@streeteasy/design-system/constants/actionElements";

import { largeScreen } from "src/shared/constants/screenSizes";

import { HeaderNavButton } from "../HeaderNavButton/styled";

export const HeaderNavLink = styled(HeaderNavButton).attrs({
  underlined: false,
  element: actionElements.a
})`
  && {
    padding: 15px;
    @media screen and (max-width: ${largeScreen}px) {
      padding: 0 15px;
    }
  }
`;
